export default function (fps, updateProxy) {
    const deltaTime = 1 / fps;
    let accumulatedTime = 0;
    let lastTime = 0;

    const tick = (timestamp) => {
        accumulatedTime += (timestamp - lastTime) / 1000;

        while(accumulatedTime > deltaTime) {
            updateProxy(deltaTime);
            accumulatedTime -= deltaTime;
        }

        lastTime = timestamp;
        requestAnimationFrame(tick);
    }

    const start = () => requestAnimationFrame(tick);

    return {
        start
    }
}